// copied from BattleCalc, because to import that is circular
const getBoardDistance = (a, b) => {
  if (!a || !b) {
    return NaN;
  }

  // const _xDif = a.x - b.x;
  // const _yDif = a.y - b.y;
  const _xDist = Math.abs(a.x - b.x); // (_xDif + (_xDif >> 31)) ^ (_xDif >> 31);
  const _yDist = Math.abs(a.y - b.y); //(_yDif + (_yDif >> 31)) ^ (_yDif >> 31);

  if (_xDist >= _yDist) {
    return _xDist;
  } else {
    return (_xDist + _yDist) * 0.5;
  }
};
module.exports = getBoardDistance;
